import Producao from '../pages/Producao/Index.vue'
import Procedimentos from '../pages/Producao/Procedimentos/Index.vue'
export default [
  {
    path: '/producao',
    component: Producao,
  },
  {
    path: '/procedimentos',
    component: Procedimentos,
  },
]
